import React from 'react';
import moment from 'moment';

class KioskPackageUpdate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: moment().format('YYYY-MM-DD'),
      time: moment().format('HH:mm'),
    };

    this.handleDateInputChange = this.handleDateInputChange.bind(this);
    this.handleTimeInputChange = this.handleTimeInputChange.bind(this);

    this.handleUpdate = this.handleUpdate.bind(this);
  }

  handleDateInputChange(event) {
    this.setState({ date: event.target.value });
  }

  handleTimeInputChange(event) {
    this.setState({ time: event.target.value });
  }

  handleUpdate() {
    const { onDone } = this.props;
    if (moment(this.state.date, 'YYYY-MM-DD', true).isValid()) {
      onDone(this.state.date.toString(), this.state.time.toString());
    } else {
      alert('Error: Date format is not correct, please try again.');
    }
  }

  render() {
    let { onCancel, selectedHostInfoList } = this.props;
    let { date } = this.state.date;
    let { time } = this.state.time;

    return (
      <div>
        <div style={{ width: 600, fontSize: 18, textAlign: 'center' }}>
          <h1>Update Security Packages for {selectedHostInfoList.length} Kiosk(s)</h1>
          <input
            name='patchDate'
            type='date'
            className='form-control'
            value={date}
            onChange={this.handleDateInputChange}
          />
          <input
            name='patchTime'
            type='time'
            className='form-control'
            value={time}
            onChange={this.handleTimeInputChange}
          />
        </div>
        <div className='modalFooter pure-g' style={{ textAlign: 'center' }}>
          <div className='pure-u-5-24'></div>
          <div className='pure-u-1-4'>
            <button className='pure-button button-regular button-aux' onClick={onCancel}>
              Cancel
            </button>
          </div>
          <div className='pure-u-1-24'></div>
          <div className='pure-u-12-24'>
            <button
              className='pure-button button-regular button-accent'
              onClick={this.handleUpdate}
            >
              Update
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default KioskPackageUpdate;



// WEBPACK FOOTER //
// ./src/components/KioskPackageUpdate.js